import { FC } from "react";
import DesignOne from "./DesignOne";
import DesignTwo from "./DesignTwo";

const RecentResearchSlide: FC = () => {
  return <DesignTwo />;
};

export default RecentResearchSlide;
